import { analytics, CreateAccountEvents } from '@/lib/analytics'

export type CreateAccountSource = 'dialog'

type CreateAccountStep = 'profile'

interface WizardOpenedEventData {
  source: CreateAccountSource
  firstAccount: boolean
}

interface StepViewedEventData {
  source: CreateAccountSource
  firstAccount: boolean
  step: CreateAccountStep
  stepNumber: number
  accountType: string | null
}

interface StepCompletedEventData {
  source: CreateAccountSource
  firstAccount: boolean
  step: CreateAccountStep
  stepNumber: number
  accountType: string | null
  durationMs: number
}

interface WizardCompletedEventData {
  source: CreateAccountSource
  firstAccount: boolean
  accountType: string
  countryCode: string
  totalDurationMs: number
}

interface WizardAbandonedEventData {
  source: CreateAccountSource
  firstAccount: boolean
  lastStep: CreateAccountStep
  accountType: string | null
  durationMs: number
}

export function trackCreateAccountWizardOpened(
  data: WizardOpenedEventData,
): void {
  analytics.track(CreateAccountEvents.WIZARD_OPENED, {
    source: data.source,
    first_account: data.firstAccount,
  })
}

export function trackCreateAccountStepViewed(data: StepViewedEventData): void {
  analytics.track(CreateAccountEvents.STEP_VIEWED, {
    source: data.source,
    first_account: data.firstAccount,
    step: data.step,
    step_number: data.stepNumber,
    account_type: data.accountType,
  })
}

export function trackCreateAccountStepCompleted(
  data: StepCompletedEventData,
): void {
  analytics.track(CreateAccountEvents.STEP_COMPLETED, {
    source: data.source,
    first_account: data.firstAccount,
    step: data.step,
    step_number: data.stepNumber,
    account_type: data.accountType,
    duration_ms: data.durationMs,
  })
}

export function trackCreateAccountWizardCompleted(
  data: WizardCompletedEventData,
): void {
  analytics.track(CreateAccountEvents.WIZARD_COMPLETED, {
    source: data.source,
    first_account: data.firstAccount,
    account_type: data.accountType,
    country_code: data.countryCode,
    total_duration_ms: data.totalDurationMs,
  })
}

export function trackCreateAccountWizardAbandoned(
  data: WizardAbandonedEventData,
): void {
  analytics.track(CreateAccountEvents.WIZARD_ABANDONED, {
    source: data.source,
    first_account: data.firstAccount,
    last_step: data.lastStep,
    account_type: data.accountType,
    duration_ms: data.durationMs,
  })
}
